import { SankeyColorStrategy } from '@blockworks/platform/api/research/studio';

const getSankeyColor = (colorStrategy: SankeyColorStrategy, sourceColor: string, targetColor: string) => {
    if (colorStrategy === SankeyColorStrategy.Source) {
        return sourceColor;
    }
    if (colorStrategy === SankeyColorStrategy.Target) {
        return targetColor;
    }
    return 'var(--color-content-deselected)';
};

export { getSankeyColor };
